export default __webpack_public_path__ + "static/0130-231da03e12013064bada1c1f5bf3cd2d.png";